<script setup>
import { ref } from 'vue';

// Define the solutions data with titles, descriptions, and paths
const solutions = ref([
  {
    title: 'Design My App',
    description: 'User-friendly UX/UI design for seamless experiences.',
    path: '/design-my-app',
  },
  {
    title: 'Build My App',
    description: 'Launch faster with a scalable, market-ready MVP.',
    path: '/build-my-app',
  },
  {
    title: 'Review My App',
    description: 'Optimize performance, security, and usability.',
    path: '/review-my-app',
  },
  {
    title: 'Roadmap My App',
    description: 'Plan your app’s future with a strategic roadmap.',
    path: '/roadmap-my-app',
  },
  {
    title: 'Staff Augmentation',
    description: 'Scale your team with top tech talent on demand.',
    path: '/staff-augmentation',
  },
  {
    title: 'Identity Management for My App',
    description: 'Secure, scalable identity solutions powered by Okta.',
    path: '/implement-identity-management',
  },
]);

// Method to scroll to the top of the page
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    // behavior: 'smooth', 
  });
};
</script>

<template>
  <div class="solution-grid">
    <h2 class="section-heading">Our <span class="highlight">Solutions</span></h2>
    <div class="grid-container">
      <div v-for="(solution, index) in solutions" :key="index" class="solution-card">
        <h3 class="card-title">{{ solution.title }}</h3>
        <p class="card-description">{{ solution.description }}</p>
        <router-link
          :to="solution.path"
          class="read-more"
          @click="scrollToTop"
        >
          Read more <span class="arrow">→</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<style scoped>
.solution-grid {
  padding: 40px 20px;
  background-color: #f7fbff;
  text-align: center;
}

.section-heading {
  font-size: 2rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 40px;
}

.highlight {
  color: #ff6860;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.solution-card {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px;
  text-align: left;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.solution-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 12px;
}

.card-description {
  font-size: 1rem;
  color: #4b5563;
  margin-bottom: 16px;
}

.read-more {
  display: inline-flex;
  align-items: center;
  font-size: 0.9375rem;
  color: #00aeff;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.read-more:hover {
  color: #007ab2;
}

.arrow {
  margin-left: 5px;
  font-size: 1.2rem;
}

/* Responsive styles */
@media (max-width: 1024px) {
  .grid-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .grid-container {
    grid-template-columns: 1fr;
  }

  .section-heading {
    font-size: 1.5rem;
  }

  .solution-card {
    padding: 16px;
  }

  .card-title {
    font-size: 1.125rem;
  }

  .card-description {
    font-size: 0.875rem;
  }
}
</style>